import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Error.css';
import useDocumentTitle from '../../hooks/useDocumentTitle';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleLeft, faQuestionCircle, faBan, faExclamationTriangle, faLock, faExclamationCircle } from "@fortawesome/free-solid-svg-icons";

export default function ErrorPage({ error, errorCode, errorMessage }) {
  useDocumentTitle('Erreur');
  const navigate = useNavigate();
  const location = useLocation();
  
  // Récupérer l'erreur depuis les props, l'état de navigation ou définir une valeur par défaut
  const errorStatus = error?.status || errorCode || location?.state?.errorCode || 404;
  const customMessage = errorMessage || location?.state?.errorMessage;

  const getErrorMessage = (status) => {
    if (status === 404) {
      return {
        title: "404 - Page non trouvée",
        message: customMessage || "Page Introuvable.",
        icon: <FontAwesomeIcon icon={faQuestionCircle} />
      };
    } else if (status === 403) {
      return {
        title: "403 - Accès refusé",
        message: customMessage || "Vous n'avez pas les permissions nécessaires pour accéder à cette page.",
        icon: <FontAwesomeIcon icon={faBan} />
      };
    } else if (status === 500) {
      return {
        title: "500 - Erreur Interne",
        message: customMessage || "Une erreur s'est produite sur Veuillez contacter l'administrateur",
        icon: <FontAwesomeIcon icon={faExclamationTriangle} />
      };
    } else if (status === 401) {
      return {
        title: "401 - Non autorisé",
        message: customMessage || "Vous devez vous connecter pour accéder à cette page.",
        icon: <FontAwesomeIcon icon={faLock} />
      };
    } else if (status === "not-open") {
      return {
        title: "Merci ...",
        message: customMessage || "Le dépôt des candidatures n'est pas encore disponible.",
        icon: <FontAwesomeIcon icon={faExclamationTriangle} />
      };
    } else {
      return {
        title: "Oops! Une erreur est survenue",
        message: customMessage || "Désolé, une erreur inattendue s'est produite.",
        icon: <FontAwesomeIcon icon={faExclamationCircle} />
      };
    }
  };

  const errorInfo = getErrorMessage(errorStatus);

  const handleGoHome = () => {
    navigate('/');
  };

  const handleGoBack = () => {
    if (window.history.length > 1) {
      navigate(-1);
    } else {
      navigate('/');
    }
  };

  return (
    <div className="error-page">
      <div className="error-container">
        {/* <div className="error-icon">{errorInfo.icon}</div> */}
        <h1 className="error-title">{errorInfo.title}</h1>
        <p className="error-message">{errorInfo.message}</p>
        
        {error?.statusText && (
          <p className="error-details">
            <i>{error.statusText}</i>
          </p>
        )}
        
        {error?.message && (
          <p className="error-details">
            <i>{error.message}</i>
          </p>
        )}

        <div className="error-actions">
          <button onClick={handleGoBack} className="btn btn-secondary">
            <FontAwesomeIcon icon={faAngleLeft} /> Retour
          </button>
          <button onClick={handleGoHome} className="btn btn-primary">
            Accueil
          </button>
        </div>

        {process.env.NODE_ENV === 'development' && error?.stack && (
          <details className="error-stack">
            <summary>Détails techniques (dev only)</summary>
            <pre>{error.stack}</pre>
          </details>
        )}
      </div>
    </div>
  );
}